import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import ProjectPopup from '../../../../Project/ProjectPopup';

// ดับเบิ้ลคลิกคอลัมน์ "งาน-รหัสงบ" → P111 project popup (ตัวเดียวกับ ExpensesTabToday.js)
export default function ProjectPopupDialog({ projectId, onClose }) {
  return (
    <Dialog
      open={!!projectId}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      sx={{ '& .MuiDialog-container': { alignItems: 'flex-start' } }}
      PaperProps={{
        sx: { mt: '40px', maxHeight: 'calc(100vh - 56px)', minWidth: '50vw' },
      }}
      hideBackdrop
    >
      <DialogContent sx={{ p: 0 }}>
        {projectId && <ProjectPopup propId={projectId} onClose={onClose} />}
      </DialogContent>
    </Dialog>
  );
}
